const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid #1a5c2a', fontFamily:"'Georgia', serif", color:'#0a1f0e', lineHeight:'1.7', background:'#f2faf4' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2e8b47', paddingBottom:'8px', marginBottom:'24px', color:'#145a24' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#1e7a36', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2e8b47', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#e8f5ec', border:'2px solid #2e8b47', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#145a24', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2e8b47' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#1e7a36', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#edf7f0' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #b6dfc0', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#145a24', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f4fbf6', border:'1px solid #b6dfc0', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#145a24', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#3a7a4a', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Details</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Metrological Traceability Chain ─────────────────────────
function DiagramTraceability() {
  const W = 900, H = 380;
  const levels = [
    { label: 'SI Unit Definition',      sub: 'e.g. metre: defined by speed of light c', bg:'#1a5c2a', fg:'#fff', w:460, icon:'🌐' },
    { label: 'Primary National Standard', sub: 'NIST / NPL / PTB — laser interferometry', bg:'#2e8b47', fg:'#fff', w:420, icon:'🏛️' },
    { label: 'Reference Standard',       sub: 'Accredited calibration lab  (ISO/IEC 17025)', bg:'#52b96a', fg:'#fff', w:380, icon:'🔬' },
    { label: 'Working Standard',          sub: 'In-house calibrated gauge blocks / artefacts', bg:'#a8d5b0', fg:'#145a24', w:340, icon:'📐' },
    { label: 'Measuring Instrument',      sub: 'Vernier caliper, CMM, micrometer, etc.', bg:'#c6efce', fg:'#145a24', w:300, icon:'🔧' },
    { label: 'Workpiece Measurement',    sub: 'Production part on the shop floor', bg:'#e8f5ec', fg:'#145a24', w:260, icon:'⚙️' },
  ];
  const boxH = 44, gap = 8, startY = 18;
  const cx = 450;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Metrological Traceability Chain — From SI Definition to Shop Floor</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="tcArrow" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto">
            <polygon points="0 0, 7 4, 0 7" fill="#546e7a"/>
          </marker>
        </defs>

        {levels.map(({ label, sub, bg, fg, w, icon }, i) => {
          const y = startY + i * (boxH + gap);
          const x = cx - w / 2;
          return (
            <g key={i}>
              {/* Connector arrow from previous level */}
              {i > 0 && (
                <line
                  x1={cx} y1={startY + (i-1)*(boxH+gap) + boxH + 1}
                  x2={cx} y2={y - 1}
                  stroke="#546e7a" strokeWidth="1.8" markerEnd="url(#tcArrow)" strokeDasharray={i===5?"5,3":"none"}
                />
              )}
              {/* Box */}
              <rect x={x} y={y} width={w} height={boxH} rx={5} fill={bg} stroke="#2e8b47" strokeWidth="1.2"/>
              {/* Level number circle */}
              <circle cx={x+22} cy={y+boxH/2} r={12} fill={fg === '#fff' ? 'rgba(255,255,255,0.25)' : '#2e8b47'} />
              <text x={x+22} y={y+boxH/2+5} textAnchor="middle" fontSize="11" fill={fg} fontWeight="700">{i+1}</text>
              {/* Icon */}
              <text x={x+46} y={y+boxH/2+6} fontSize="16">{icon}</text>
              {/* Label */}
              <text x={x+68} y={y+16} fontSize="12" fill={fg} fontWeight="700">{label}</text>
              <text x={x+68} y={y+31} fontSize="10" fill={fg} opacity="0.85">{sub}</text>
              {/* Uncertainty annotation on right */}
              {i > 0 && (
                <text x={cx + w/2 + 10} y={y + boxH/2 + 5} fontSize="10" fill="#546e7a" fontStyle="italic">
                  {['','± 0.0001 µm','± 0.01 µm','± 0.1 µm','± 1 µm','± 5–50 µm'][i]}
                </text>
              )}
            </g>
          );
        })}

        {/* Right-side label: uncertainty grows */}
        <text x={W-12} y={startY + 1.5*(boxH+gap)} fontSize="11" fill="#1e7a36" fontWeight="700" textAnchor="end">Uncertainty</text>
        <text x={W-12} y={startY + 1.5*(boxH+gap)+14} fontSize="11" fill="#1e7a36" fontWeight="700" textAnchor="end">increases ↓</text>
        <line x1={W-30} y1={startY+2*(boxH+gap)} x2={W-30} y2={startY+5*(boxH+gap)+boxH} stroke="#1e7a36" strokeWidth="2" strokeDasharray="4,3"/>
        <polygon points={`${W-36},${startY+5*(boxH+gap)+boxH} ${W-24},${startY+5*(boxH+gap)+boxH} ${W-30},${startY+5*(boxH+gap)+boxH+10}`} fill="#1e7a36"/>
      </svg>
      <div style={S.dCaption}>Traceability is the unbroken chain of calibrations linking a measurement result back to an SI unit definition. Each link introduces additional uncertainty — a calibration certificate must document the expanded uncertainty U (k=2, ~95% confidence). Without traceability, measurement results cannot be compared globally or legally defended.</div>
    </div>
  );
}

// ── Diagram 2: CMM Anatomy ──────────────────────────────────────────
function DiagramCMM() {
  // Three-column layout:
  //   Col A  x=0..210   : annotation labels (right-aligned)
  //   Col B  x=215..595 : CMM drawing
  //   Col C  x=610..980 : CMM Types panel
  const W = 980, H = 460;
  const labelMaxX = 208;   // right edge of label text
  const machL     = 218;   // left edge of CMM drawing
  const machCX    = 400;   // centre of CMM body
  const panelX    = 612;   // left edge of right info panel

  // Each annotation: where the dot sits on the CMM, and what the label says
  const annots = [
    { dotX: machCX,      dotY: 119, label: 'X-axis bridge (travel ±150–1000 mm)' },
    { dotX: machL + 20,  dotY: 160, label: 'Y-axis column (granite guideway)'    },
    { dotX: machCX - 13, dotY: 204, label: 'Z-axis quill — glass scale encoder'  },
    { dotX: machCX,      dotY: 286, label: 'Probe head — motorised (Renishaw PH10)' },
    { dotX: machCX,      dotY: 340, label: 'Ruby stylus tip — Ø 0.5–6 mm, calibrated' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Coordinate Measuring Machine (CMM) — Anatomy &amp; Operation</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <linearGradient id="granite" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#b0b8c0"/>
            <stop offset="100%" stopColor="#78828c"/>
          </linearGradient>
          <linearGradient id="alum" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#d0dce4"/>
            <stop offset="100%" stopColor="#90a4ae"/>
          </linearGradient>
          <marker id="cmmArr"  markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="cmmArrG" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#1e7a36"/>
          </marker>
          <marker id="cmmArrO" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#e07b00"/>
          </marker>
          <marker id="dotEnd" markerWidth="5" markerHeight="5" refX="5" refY="2.5" orient="auto">
            <circle cx="2.5" cy="2.5" r="2.5" fill="#546e7a"/>
          </marker>
        </defs>

        {/* ── COL A: Annotation labels — entirely in x=0..208 ── */}
        {annots.map(({ dotX, dotY, label }, i) => (
          <g key={i}>
            {/* Label text — right-aligned so it ends exactly at labelMaxX */}
            <text x={labelMaxX} y={dotY + 4} textAnchor="end"
                  fontSize="10" fill="#333">{label}</text>
            {/* Leader line: from just right of label to just left of the dot */}
            <line
              x1={labelMaxX + 4} y1={dotY}
              x2={dotX - 6}       y2={dotY}
              stroke="#546e7a" strokeWidth="1" strokeDasharray="4,3"/>
            {/* Dot on the CMM component */}
            <circle cx={dotX} cy={dotY} r={3} fill="#546e7a"/>
          </g>
        ))}

        {/* ── COL B: CMM Drawing (x: 218..595) ── */}

        {/* Granite surface plate */}
        <rect x={machL + 8} y={348} width={362} height={52} rx={4}
              fill="url(#granite)" stroke="#546e7a" strokeWidth="2"/>
        <text x={machCX} y={379} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">
          Granite Surface Plate (reference datum)
        </text>
        <text x={machCX} y={393} textAnchor="middle" fontSize="10" fill="#e0e8f0">
          Flatness ≤ 2 µm / 500 mm  |  20°C ± 0.5°C
        </text>

        {/* Left column */}
        <rect x={machL + 18} y={136} width={30} height={212} rx={3}
              fill="url(#alum)" stroke="#78909c" strokeWidth="1.5"/>
        {/* Right column */}
        <rect x={machL + 330} y={136} width={30} height={212} rx={3}
              fill="url(#alum)" stroke="#78909c" strokeWidth="1.5"/>

        {/* Bridge beam */}
        <rect x={machL + 8} y={106} width={362} height={28} rx={3}
              fill="url(#alum)" stroke="#78909c" strokeWidth="1.5"/>
        <text x={machCX} y={125} textAnchor="middle" fontSize="10" fill="#145a24" fontWeight="700">
          X-axis bridge
        </text>

        {/* Z-axis quill */}
        <rect x={machCX - 13} y={132} width={26} height={140} rx={3}
              fill="#c6efce" stroke="#1a5c2a" strokeWidth="1.5"/>
        <text x={machCX} y={210} textAnchor="middle" fontSize="9" fill="#145a24" fontWeight="700"
              transform={`rotate(-90 ${machCX} 210)`}>Z-axis ram</text>

        {/* Probe head */}
        <circle cx={machCX} cy={286} r={17} fill="#1a5c2a" stroke="#145a24" strokeWidth="2"/>
        <text x={machCX} y={291} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">PH</text>

        {/* Stylus shaft + ruby tip */}
        <line x1={machCX} y1={303} x2={machCX} y2={332} stroke="#78909c" strokeWidth="3"/>
        <circle cx={machCX} cy={340} r={7} fill="#c0392b" stroke="#8b0000" strokeWidth="1.5"/>

        {/* Workpiece */}
        <rect x={machCX - 65} y={310} width={115} height={38} rx={3}
              fill="#e07b00" stroke="#bf6000" strokeWidth="1.5" opacity="0.88"/>
        <text x={machCX - 8} y={333} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">Workpiece</text>

        {/* Axis triad */}
        <circle cx={machL + 30} cy={425} r={4} fill="#333"/>
        <line x1={machL+30} y1={425} x2={machL+80} y2={425}
              stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#cmmArr)"/>
        <text x={machL+84} y={429} fontSize="11" fill="#c0392b" fontWeight="700">X</text>
        <line x1={machL+30} y1={425} x2={machL+10} y2={397}
              stroke="#1e7a36" strokeWidth="2.5" markerEnd="url(#cmmArrG)"/>
        <text x={machL} y={393} textAnchor="end" fontSize="11" fill="#1e7a36" fontWeight="700">Y</text>
        <line x1={machL+30} y1={425} x2={machL+30} y2={370}
              stroke="#e07b00" strokeWidth="2.5" markerEnd="url(#cmmArrO)"/>
        <text x={machL+36} y={366} fontSize="11" fill="#e07b00" fontWeight="700">Z</text>
        <text x={machL+30} y={445} textAnchor="middle" fontSize="9" fill="#555" fontStyle="italic">origin</text>

        {/* ── COL C: CMM Types panel (x: 612..976) ── */}
        <rect x={panelX} y={16} width={364} height={428} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={panelX + 182} y={38} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">CMM Types</text>

        {[
          { name:'Bridge',         l1:'Most common; granite bridge',  l2:'moves over fixed table',       acc:'0.5–3 µm'  },
          { name:'Gantry',         l1:'Large workpieces (cars,',      l2:'turbines); overhead bridge',   acc:'2–10 µm'   },
          { name:'Horizontal arm', l1:'Sheet-metal, body-in-white;',  l2:'high reach, lower accuracy',  acc:'5–20 µm'   },
          { name:'Portable arm',   l1:'Shop-floor; articulated',      l2:'6-DOF arm with probe',        acc:'20–80 µm'  },
          { name:'Optical / CT',   l1:'Non-contact; laser scanner',   l2:'or X-ray CT for internals',   acc:'1–50 µm'   },
        ].map(({ name, l1, l2, acc }, i) => {
          const ry = 46 + i * 74;
          return (
            <g key={i}>
              <rect x={panelX+6} y={ry} width={352} height={66} rx={3}
                    fill={i%2===0?'#edf7f0':'#fff'} stroke="#b6dfc0" strokeWidth="1"/>
              <text x={panelX+14} y={ry+19} fontSize="11" fill="#145a24" fontWeight="700">{name}</text>
              <text x={panelX+14} y={ry+34} fontSize="10" fill="#444">{l1}</text>
              <text x={panelX+14} y={ry+49} fontSize="10" fill="#444">{l2}</text>
              <text x={panelX+344} y={ry+19} textAnchor="end" fontSize="10" fill="#1e7a36" fontWeight="700">{acc}</text>
              <text x={panelX+344} y={ry+33} textAnchor="end" fontSize="9"  fill="#546e7a">accuracy</text>
            </g>
          );
        })}
        <text x={panelX+182} y={432} textAnchor="middle" fontSize="10" fill="#546e7a" fontStyle="italic">
          Volumetric accuracy per ISO 10360-2
        </text>
      </svg>
      <div style={S.dCaption}>A bridge CMM uses three linear axes (X, Y, Z) with glass scale encoders to locate a probe tip in 3D space. The probe records discrete point coordinates which are fitted to geometric primitives (planes, cylinders, cones) by least-squares algorithms. Accuracy is governed by machine geometry errors, probe qualification, thermal expansion, and workpiece fixturing — all quantified in the uncertainty budget.</div>
    </div>
  );
}

// ── Diagram 3: GD&T Symbols Reference ──────────────────────────────
function DiagramGDT() {
  const W = 960, H = 560;
  const symbols = [
    { cat:'FORM',        sym:'—',  name:'Straightness',        ex:'⎯  0.05',       desc:'Deviation of a line element from a perfect straight line' },
    { cat:'FORM',        sym:'□',  name:'Flatness',             ex:'⏥  0.02',       desc:'All surface points within two parallel planes 0.02 apart' },
    { cat:'FORM',        sym:'○',  name:'Circularity',          ex:'○  0.01',       desc:'Roundness — cross-section within two concentric circles' },
    { cat:'FORM',        sym:'⌭',  name:'Cylindricity',         ex:'⌭  0.03',       desc:'All surface points within two coaxial cylinders' },
    { cat:'ORIENT.',     sym:'∥',  name:'Parallelism',          ex:'∥  0.05 A',     desc:'Feature axis or surface parallel to datum A within 0.05' },
    { cat:'ORIENT.',     sym:'⊥',  name:'Perpendicularity',     ex:'⊥  0.02 A',     desc:'Feature axis perpendicular to datum A within Ø0.02' },
    { cat:'ORIENT.',     sym:'∠',  name:'Angularity',           ex:'∠  0.04 A',     desc:'Feature at specified angle to datum within tolerance zone' },
    { cat:'LOCATION',    sym:'⊕',  name:'True Position',        ex:'⊕ Ø0.1 A B C', desc:'Axis/plane within cylindrical zone from true position' },
    { cat:'LOCATION',    sym:'◎',  name:'Concentricity',        ex:'◎ Ø0.02 A',     desc:'Centre of feature coincident with datum axis' },
    { cat:'LOCATION',    sym:'=',  name:'Symmetry',             ex:'= 0.05 A',      desc:'Feature symmetrical about a datum plane' },
    { cat:'RUNOUT',      sym:'↗',  name:'Circular Runout',      ex:'↗  0.03 A',     desc:'Variation per revolution at any cross-section' },
    { cat:'RUNOUT',      sym:'⇗',  name:'Total Runout',         ex:'⇗  0.05 A',     desc:'Variation across full feature surface during rotation' },
    { cat:'PROFILE',     sym:'⌓',  name:'Profile of a Line',    ex:'⌓  0.04',       desc:'Tolerance zone along a 2D curve — bilateral or unilateral' },
    { cat:'PROFILE',     sym:'⌔',  name:'Profile of a Surface', ex:'⌔  0.08 A',     desc:'All surface points within uniform zone around true profile' },
  ];

  const cols = 2;
  const nRows = Math.ceil(symbols.length / cols);
  const headerH = 30;
  const cellW = W / cols;
  const cellH = (H - headerH) / nRows;   // ~37 px per row → enough for 3 text lines

  const catColors = {
    'FORM':     { bg:'#e8f5ec', bc:'#2e8b47', tc:'#145a24' },
    'ORIENT.':  { bg:'#fff8e1', bc:'#e07b00', tc:'#5a3200' },
    'LOCATION': { bg:'#e8f0ff', bc:'#3a5bbf', tc:'#1a2e7a' },
    'RUNOUT':   { bg:'#fce4ec', bc:'#c62828', tc:'#7a0010' },
    'PROFILE':  { bg:'#f3e5f5', bc:'#7b1fa2', tc:'#3d0063' },
  };

  // Simple word-wrap helper
  function wrapText(text, maxChars) {
    const words = text.split(' ');
    const lines = [];
    let line = '';
    for (const w of words) {
      if (line && (line + ' ' + w).length > maxChars) { lines.push(line); line = w; }
      else { line = line ? line + ' ' + w : w; }
    }
    if (line) lines.push(line);
    return lines;
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>GD&amp;T (Geometric Dimensioning &amp; Tolerancing) — Symbol Reference (ASME Y14.5 / ISO 1101)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Column headers */}
        <rect x={0} y={0} width={W} height={headerH} fill="#1e7a36"/>
        <text x={W/4}   y={20} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">Characteristic</text>
        <text x={3*W/4} y={20} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">Characteristic</text>

        {symbols.map(({ cat, sym, name, ex, desc }, idx) => {
          const col  = idx % cols;
          const row  = Math.floor(idx / cols);
          const cx   = col * cellW;
          const cy   = headerH + row * cellH;
          const { bg, bc, tc } = catColors[cat];
          const lines = wrapText(desc, 40);
          return (
            <g key={idx}>
              <rect x={cx+1} y={cy+1} width={cellW-2} height={cellH-2} rx={3} fill={bg} stroke={bc} strokeWidth="1.2"/>
              {/* Category badge */}
              <rect x={cx+6} y={cy+6} width={56} height={16} rx={3} fill={bc}/>
              <text x={cx+34} y={cy+18} textAnchor="middle" fontSize="8.5" fill="#fff" fontWeight="700">{cat}</text>
              {/* Symbol — vertically centred in cell */}
              <text x={cx+76} y={cy+cellH/2+8} textAnchor="middle" fontSize="24" fill={tc}>{sym}</text>
              {/* Name */}
              <text x={cx+104} y={cy+18} fontSize="12" fill={tc} fontWeight="700">{name}</text>
              {/* Example FCF */}
              <text x={cx+104} y={cy+33} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{ex}</text>
              {/* Description — wrapped, max 2 lines */}
              {lines.slice(0,2).map((l, li) => (
                <text key={li} x={cx+104} y={cy+48+li*14} fontSize="10" fill="#555">{l}</text>
              ))}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>GD&T is the symbolic language on engineering drawings that defines part geometry beyond simple ± tolerances. Each Feature Control Frame (FCF) contains: the geometric symbol, the tolerance value, and the datum references. ISO 1101 and ASME Y14.5-2018 are the two dominant standards; they are similar but differ in interpretation of some symbols and modifiers (MMC, LMC, RFS).</div>
    </div>
  );
}

// ── Diagram 4: Measurement Uncertainty Budget ──────────────────────
function DiagramUncertainty() {
  const W = 960, H = 400;
  const contributors = [
    { name: 'Machine geometry errors',  ui: 1.2, type: 'B', color: '#1a5c2a' },
    { name: 'Probe qualification',      ui: 0.6, type: 'B', color: '#2e8b47' },
    { name: 'Thermal expansion (part)', ui: 1.8, type: 'B', color: '#52b96a' },
    { name: 'Thermal expansion (CMM)',  ui: 0.8, type: 'B', color: '#a8d5b0' },
    { name: 'Workpiece fixturing',      ui: 0.9, type: 'B', color: '#c6efce' },
    { name: 'Repeatability (Type A)',   ui: 0.4, type: 'A', color: '#e07b00' },
    { name: 'Stylus qualification',     ui: 0.3, type: 'B', color: '#78909c' },
    { name: 'Software (fitting alg.)',  ui: 0.2, type: 'B', color: '#b0bec5' },
  ];
  const uc = Math.sqrt(contributors.reduce((s, c) => s + c.ui * c.ui, 0));
  const U  = (2 * uc).toFixed(2);

  // Column layout (all within W=960)
  // Col 0: name  0–200
  // Col 1: type  200–238
  // Col 2: bar   238–620
  // Col 3: ui²   620–680
  // Col 4: %bar+label  680–960
  const cL = 238, cR = 620;
  const maxU = 2.0;
  const bx = u => cL + (u / maxU) * (cR - cL);
  const barH = 22, rowH = 34;
  const cT = 28, cB = cT + contributors.length * rowH;
  const totalUc2 = contributors.reduce((s, c) => s + c.ui * c.ui, 0);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Measurement Uncertainty Budget — CMM Dimensional Measurement Example</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Header row */}
        <rect x={0} y={0} width={W} height={cT} fill="#1e7a36"/>
        <text x={100} y={18} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">Uncertainty Source</text>
        <text x={219} y={18} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">Type</text>
        <text x={(cL+cR)/2} y={18} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">Standard Uncertainty uᵢ (µm)</text>
        <text x={648} y={18} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">uᵢ²</text>
        <text x={820} y={18} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">% contribution</text>

        {/* X-axis grid lines inside bar area */}
        {[0, 0.5, 1.0, 1.5, 2.0].map(v => (
          <line key={v} x1={bx(v)} y1={cT} x2={bx(v)} y2={cB}
                stroke="#b6dfc0" strokeWidth="1" strokeDasharray="3,3"/>
        ))}

        {/* Data rows */}
        {contributors.map(({ name, ui, type, color }, i) => {
          const y = cT + i * rowH;
          const uc2 = (ui * ui).toFixed(2);
          const pct = Math.round((ui * ui / totalUc2) * 100);
          const pctBarW = Math.min(pct * 1.8, 240); // max ~240px for 100%
          return (
            <g key={i}>
              <rect x={0} y={y} width={W} height={rowH-1} fill={i%2===0?'#f4fbf6':'#fff'} opacity="0.7"/>
              {/* Name */}
              <text x={8} y={y+rowH/2+4} fontSize="10.5" fill="#0a1f0e">{name}</text>
              {/* Type badge */}
              <rect x={200} y={y+7} width={30} height={18} rx={3} fill={type==='A'?'#e07b00':'#2e8b47'}/>
              <text x={215} y={y+20} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">{type}</text>
              {/* Bar */}
              <rect x={cL} y={y+5} width={bx(ui)-cL} height={barH} rx={2} fill={color} opacity="0.88"/>
              <text x={bx(ui)+4} y={y+5+barH/2+4} fontSize="9" fill="#333">{ui}</text>
              {/* uᵢ² value */}
              <text x={648} y={y+rowH/2+4} textAnchor="middle" fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{uc2}</text>
              {/* % mini-bar + label */}
              <rect x={680} y={y+8} width={pctBarW} height={16} rx={2} fill={color} opacity="0.5"/>
              <text x={928} y={y+rowH/2+4} textAnchor="end" fontSize="10" fill="#333">{pct}%</text>
            </g>
          );
        })}

        {/* X-axis tick labels — below bar area */}
        {[0, 0.5, 1.0, 1.5, 2.0].map(v => (
          <text key={v} x={bx(v)} y={cB+12} textAnchor="middle" fontSize="9" fill="#555">{v}</text>
        ))}
        <text x={(cL+cR)/2} y={cB+24} textAnchor="middle" fontSize="10" fill="#555">Standard uncertainty uᵢ (µm) →</text>

        {/* Summary box */}
        <rect x={0} y={cB+30} width={W} height={46} fill="#1e7a36" opacity="0.10"/>
        <rect x={0} y={cB+30} width={W} height={46} fill="none" stroke="#2e8b47" strokeWidth="1.5"/>
        <text x={8} y={cB+48} fontSize="11" fill="#145a24" fontWeight="700">
          Combined standard uncertainty:  u_c = √(Σ uᵢ²) = {uc.toFixed(2)} µm
        </text>
        <text x={8} y={cB+66} fontSize="11" fill="#145a24" fontWeight="700">
          Expanded uncertainty (k=2, ~95%):  U = 2 × u_c = {U} µm
        </text>

        {/* Legend — top right, inside chart */}
        <rect x={W-260} y={cT+4} width={16} height={10} fill="#e07b00" opacity="0.9"/>
        <text x={W-240} y={cT+13} fontSize="10" fill="#333">Type A — statistical (repeat measurements)</text>
        <rect x={W-260} y={cT+20} width={16} height={10} fill="#2e8b47" opacity="0.9"/>
        <text x={W-240} y={cT+29} fontSize="10" fill="#333">Type B — prior knowledge / calibration certs</text>
      </svg>
      <div style={S.dCaption}>An uncertainty budget (per GUM — Guide to the Expression of Uncertainty in Measurement) identifies every significant contribution to measurement uncertainty, assigns a standard uncertainty uᵢ to each, and combines them in quadrature. Thermal effects typically dominate CMM uncertainty for parts larger than ~200 mm. The expanded uncertainty U (k=2) must be smaller than ~25% of the drawing tolerance for the measurement to be metrologically valid.</div>
    </div>
  );
}

// ── Diagram 5: Surface Roughness Profiles ──────────────────────────
function DiagramSurfaceRoughness() {
  const W = 960, H = 420;

  function profile(seed, amp, freq, points) {
    points = points || 200;
    const pts = [];
    for (let i = 0; i < points; i++) {
      const x = (i / (points - 1)) * 360;
      const y = amp * (
        Math.sin(freq * i * 0.4 + seed) * 0.5 +
        Math.sin(freq * i * 1.1 + seed * 2) * 0.3 +
        Math.sin(freq * i * 2.7 + seed * 0.7) * 0.2
      );
      pts.push([x, y]);
    }
    return pts;
  }

  function toPath(pts, ox, oy, scaleY) {
    return pts.map(function(p, i) {
      return (i === 0 ? 'M' : 'L') + (ox + p[0]).toFixed(1) + ',' + (oy + p[1] * scaleY).toFixed(1);
    }).join(' ');
  }

  const roughPts  = profile(1.3, 20, 0.8);
  const groundPts = profile(2.1, 8,  0.8);
  const honedPts  = profile(0.7, 14, 1.6);

  const panels = [
    { pts: roughPts,  label:'Turned surface',  process:'Rough turning',        Ra:'3.2 µm', Rz:'16 µm',  scaleY:1,    col:'#c0392b' },
    { pts: groundPts, label:'Ground surface',  process:'Cylindrical grinding', Ra:'0.8 µm', Rz:'4 µm',   scaleY:0.36, col:'#1e7a36' },
    { pts: honedPts,  label:'Honed surface',   process:'Honing',               Ra:'0.2 µm', Rz:'1.6 µm', scaleY:0.64, col:'#e07b00' },
  ];

  const panelW   = W / 3;   // 320 px each
  const profW    = 300;     // profile drawn within this x-span, centred in panel

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Surface Texture — Ra and Rz Parameters &amp; Process Comparison</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="srArrB" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0, 5 3, 0 6" fill="#546e7a"/>
          </marker>
          <marker id="srArrR" markerWidth="6" markerHeight="6" refX="5" refY="3" orient="auto">
            <polygon points="0 0, 5 3, 0 6" fill="#c0392b"/>
          </marker>
          {panels.map(function(_, pi) {
            return (
              <clipPath key={pi} id={`srclip${pi}`}>
                <rect x={pi*panelW+3} y={3} width={panelW-6} height={H-6}/>
              </clipPath>
            );
          })}
        </defs>

        {panels.map(function({ pts, label, process, Ra, Rz, scaleY, col }, pi) {
          const panelX  = pi * panelW;
          const ox      = panelX + (panelW - profW) / 2;
          const oy      = 148;
          const scaled  = pts.map(function(p) { return [p[0] * (profW / 360), p[1]]; });
          const ys      = scaled.map(function(p) { return p[1] * scaleY; });
          const maxY    = Math.max.apply(null, ys);
          const minY    = Math.min.apply(null, ys);
          const raPixels = scaled.reduce(function(s, p) { return s + Math.abs(p[1]); }, 0) / scaled.length;

          return (
            <g key={pi} clipPath={`url(#srclip${pi})`}>
              {/* Panel */}
              <rect x={panelX+2} y={2} width={panelW-4} height={H-4} rx={5}
                    fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
              {/* Titles */}
              <text x={panelX+panelW/2} y={22} textAnchor="middle" fontSize="12" fill="#145a24" fontWeight="700">{label}</text>
              <text x={panelX+panelW/2} y={38} textAnchor="middle" fontSize="10" fill="#546e7a">{process}</text>
              {/* Axes */}
              <line x1={ox} y1={oy-56} x2={ox} y2={oy+58} stroke="#333" strokeWidth="1.2"/>
              <line x1={ox} y1={oy+58} x2={ox+profW} y2={oy+58} stroke="#333" strokeWidth="1.2"/>
              <text x={panelX+panelW/2} y={oy+72} textAnchor="middle" fontSize="9" fill="#555">sampling length</text>
              {/* Mean line + label inside panel */}
              <line x1={ox} y1={oy} x2={ox+profW} y2={oy} stroke="#546e7a" strokeWidth="1" strokeDasharray="4,3"/>
              <text x={ox+profW-4} y={oy-4} textAnchor="end" fontSize="9" fill="#546e7a">mean</text>
              {/* Ra band */}
              <rect x={ox} y={oy-raPixels*scaleY} width={profW} height={raPixels*scaleY*2}
                    fill={col} opacity="0.07" rx={1}/>
              {/* Profile */}
              <path d={toPath(scaled, ox, oy, scaleY)} fill="none" stroke={col} strokeWidth="1.5"/>
              {/* Ra annotation */}
              <line x1={ox+55} y1={oy-raPixels*scaleY} x2={ox+55} y2={oy}
                    stroke="#546e7a" strokeWidth="1"
                    markerStart="url(#srArrB)" markerEnd="url(#srArrB)"/>
              <text x={ox+59} y={oy-raPixels*scaleY/2+4} fontSize="9" fill="#546e7a" fontWeight="700">Ra</text>
              {/* Rz annotation */}
              <line x1={ox+220} y1={oy+maxY} x2={ox+220} y2={oy+minY}
                    stroke="#c0392b" strokeWidth="1"
                    markerStart="url(#srArrR)" markerEnd="url(#srArrR)"/>
              <text x={ox+224} y={oy+(maxY+minY)/2+4} fontSize="9" fill="#c0392b" fontWeight="700">Rz</text>
              {/* Stats box */}
              <rect x={panelX+8} y={236} width={panelW-16} height={88} rx={3}
                    fill="#edf7f0" stroke={col} strokeWidth="1.2"/>
              <text x={panelX+16} y={254} fontSize="11" fill="#145a24" fontWeight="700">Ra = {Ra}</text>
              <text x={panelX+16} y={270} fontSize="11" fill="#c0392b" fontWeight="700">Rz = {Rz}</text>
              <text x={panelX+16} y={286} fontSize="9.5" fill="#546e7a">Ra: arithmetic mean deviation</text>
              <text x={panelX+16} y={300} fontSize="9.5" fill="#546e7a">Rz: max peak-to-valley height</text>
              <text x={panelX+16} y={317} fontSize="9.5" fill="#333" fontStyle="italic">
                {pi===0?'ISO grade: N9 (Ra 3.2)':pi===1?'ISO grade: N6 (Ra 0.8)':'ISO grade: N4 (Ra 0.2)'}
              </text>
              {/* Grade triangles */}
              <text x={panelX+panelW/2} y={358} textAnchor="middle" fontSize="26" fill={col} opacity="0.65">
                {pi===0?'▲▲▲':pi===1?'▲▲':'▲'}
              </text>
              <text x={panelX+panelW/2} y={380} textAnchor="middle" fontSize="10" fill="#555">
                {pi===0?'rough':pi===1?'medium':'fine / precision'}
              </text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Surface texture (ISO 4287 / ISO 25178) quantifies the micro-geometry of a machined surface. Ra (arithmetic mean roughness) is the most common parameter; Rz (maximum height) is better for functional surfaces like seals and bearings. Stylus profilometers (contact) and optical interferometers (non-contact) measure these profiles. The choice of cut-off wavelength λ_c (typically 0.8 mm for turned surfaces) separates roughness from waviness.</div>
    </div>
  );
}

// ── Diagram 6: SPC Control Chart & Gauge R&R ──────────────────────
function DiagramSPC() {
  const W = 980, H = 420;

  const seed = (i) => Math.sin(i * 127.1 + 3.7) * 0.5 + Math.sin(i * 311.3 + 1.2) * 0.3 + Math.sin(i * 53.9) * 0.2;
  const nominal = 50.0;
  const sigma = 0.015;
  const xbars = Array.from({length:25}, (_, i) => {
    const base = nominal + seed(i) * sigma * 2.5;
    return i === 17 ? nominal + sigma * 4.2 : i === 22 ? nominal - sigma * 3.8 : base;
  });

  const grandMean = xbars.reduce((s,v) => s+v, 0) / xbars.length;
  const UCL = grandMean + 3 * sigma;
  const LCL = grandMean - 3 * sigma;
  const UWL = grandMean + 2 * sigma;
  const LWL = grandMean - 2 * sigma;

  // Chart area — left portion of viewBox
  const cL = 60, cR = 580, cT = 40, cB = 310;
  const cW = cR - cL, cH = cB - cT;
  const nGroups = 25;
  const px = (i) => cL + (i / (nGroups - 1)) * cW;
  const py = (v) => {
    const range = UCL - LCL;
    const pad = range * 0.3;
    return cB - ((v - (LCL - pad)) / (range + 2*pad)) * cH;
  };

  // Right panel occupies x=596 to x=976 (width=380)
  const rpX = 596, rpW = 376;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Statistical Process Control — X̄ Control Chart &amp; Cp / Cpk Process Capability</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* ── Chart title ── */}
        <text x={cL + cW/2} y={cT-10} textAnchor="middle" fontSize="12" fill="#145a24" fontWeight="700">
          X̄ Control Chart — Bore diameter (nominal {nominal} mm)
        </text>

        {/* ── Chart background ── */}
        <rect x={cL} y={cT} width={cW} height={cH} rx={3} fill="#f4fbf6" stroke="#b6dfc0"/>

        {/* Zone bands */}
        <rect x={cL} y={py(UWL)} width={cW} height={py(UCL)-py(UWL)} fill="#c0392b" opacity="0.06"/>
        <rect x={cL} y={py(LCL)} width={cW} height={py(LWL)-py(LCL)} fill="#c0392b" opacity="0.06"/>
        <rect x={cL} y={py(UWL)} width={cW} height={py(LWL)-py(UWL)} fill="#1e7a36" opacity="0.05"/>

        {/* Control lines */}
        {[
          {v: UCL, label:'UCL', col:'#c0392b', dash:'none'},
          {v: UWL, label:'+2σ', col:'#e07b00', dash:'5,4'},
          {v: grandMean, label:'X̄', col:'#1e7a36', dash:'none'},
          {v: LWL, label:'−2σ', col:'#e07b00', dash:'5,4'},
          {v: LCL, label:'LCL', col:'#c0392b', dash:'none'},
        ].map(({v,label,col,dash}) => (
          <g key={label}>
            <line x1={cL} y1={py(v)} x2={cR} y2={py(v)}
                  stroke={col} strokeWidth={label==='X̄'?2:1.2} strokeDasharray={dash}/>
            <text x={cL-4} y={py(v)+4} textAnchor="end" fontSize="9" fill={col} fontWeight="700">{label}</text>
            <text x={cR+3} y={py(v)+4} fontSize="9" fill={col}>{v.toFixed(3)}</text>
          </g>
        ))}

        {/* Data line */}
        <path d={xbars.map((v, i) => (i===0?'M':'L') + px(i).toFixed(1) + ',' + py(v).toFixed(1)).join(' ')}
              fill="none" stroke="#1e7a36" strokeWidth="1.5"/>

        {/* Data points */}
        {xbars.map((v, i) => {
          const ooc  = v > UCL || v < LCL;
          const warn = !ooc && (v > UWL || v < LWL);
          return (
            <g key={i}>
              <circle cx={px(i)} cy={py(v)} r={ooc ? 7 : 4}
                      fill={ooc ? '#c0392b' : warn ? '#e07b00' : '#1e7a36'}
                      stroke="#fff" strokeWidth="1"/>
              {ooc && <text x={px(i)} y={py(v)-10} textAnchor="middle" fontSize="9" fill="#c0392b" fontWeight="700">OOC</text>}
            </g>
          );
        })}

        {/* X-axis labels */}
        {[1,5,10,15,20,25].map(n => (
          <text key={n} x={px(n-1)} y={cB+14} textAnchor="middle" fontSize="9" fill="#555">{n}</text>
        ))}
        <text x={cL+cW/2} y={cB+28} textAnchor="middle" fontSize="11" fill="#333">Subgroup number →</text>
        <text x={cL-46} y={cT+cH/2} textAnchor="middle" fontSize="11" fill="#333"
              transform={`rotate(-90 ${cL-46} ${cT+cH/2})`}>X̄ (mm)</text>

        {/* ── Right panel ── */}
        <rect x={rpX} y={cT} width={rpW} height={cH} rx={5} fill="#fff" stroke="#b6dfc0" strokeWidth="1.2"/>
        <text x={rpX+rpW/2} y={cT+18} textAnchor="middle" fontSize="13" fill="#145a24" fontWeight="700">Process Capability</text>

        {/* Cp/Cpk/Pp cards — each 56px tall, 8px gap */}
        {[
          { label:'Cp',     formula:'(USL − LSL) / (6σ)',          desc1:'Potential capability —',    desc2:'spread vs. tolerance width', val:'1.45', good:true  },
          { label:'Cpk',    formula:'min[(USL−X̄)/3σ, (X̄−LSL)/3σ]', desc1:'Actual capability —',       desc2:'accounts for centering',     val:'1.22', good:true  },
          { label:'Pp',     formula:'(USL − LSL) / (6s)',          desc1:'Performance index using',   desc2:'overall std deviation s',     val:'1.38', good:true  },
          { label:'Target', formula:'Cp, Cpk ≥ 1.33  (4σ)',       desc1:'Industry minimum for',      desc2:'critical dimensions',         val:'≥1.33',good:false },
        ].map(({ label, formula, desc1, desc2, val, good }, i) => {
          const cy = cT + 30 + i * 54;
          return (
            <g key={label}>
              <rect x={rpX+6} y={cy} width={rpW-12} height={50} rx={3}
                    fill={good?'#edf7f0':'#fff8e1'} stroke={good?'#2e8b47':'#e07b00'} strokeWidth="1"/>
              <text x={rpX+14} y={cy+16} fontSize="12" fill="#145a24" fontWeight="700">{label}</text>
              <text x={rpX+62} y={cy+13} fontSize="9" fill="#333" fontFamily="'Courier New',monospace">{formula}</text>
              <text x={rpX+14} y={cy+30} fontSize="9.5" fill="#555">{desc1}</text>
              <text x={rpX+14} y={cy+42} fontSize="9.5" fill="#555">{desc2}</text>
              {/* Value badge — right aligned within panel */}
              <rect x={rpX+rpW-54} y={cy+8} width={44} height={24} rx={3}
                    fill={good?'#1e7a36':'#e07b00'}/>
              <text x={rpX+rpW-32} y={cy+24} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">{val}</text>
            </g>
          );
        })}

        {/* OOC legend box */}
        {(()=>{
          const oocY = cT + 30 + 4*54 + 6;
          return (
            <g>
              <rect x={rpX+6} y={oocY} width={rpW-12} height={52} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
              <circle cx={rpX+20} cy={oocY+16} r={7} fill="#c0392b"/>
              <text x={rpX+32} y={oocY+20} fontSize="10" fill="#c0392b" fontWeight="700">OOC = Out of Control (Rule 1: beyond ±3σ)</text>
              <text x={rpX+14} y={oocY+35} fontSize="9.5" fill="#555">Investigate special cause; stop production</text>
              <text x={rpX+14} y={oocY+47} fontSize="9.5" fill="#555">until root cause identified and corrected</text>
            </g>
          );
        })()}
      </svg>
      <div style={S.dCaption}>A Shewhart X̄ control chart plots the subgroup mean over time against control limits at ±3σ (UCL/LCL). Points beyond the control limits (OOC — out-of-control) signal a special cause requiring immediate investigation. Cp measures whether the process spread fits within the tolerance; Cpk additionally measures how well it is centred. A Cpk ≥ 1.33 means the process mean is at least 4σ from either specification limit — the typical minimum for safety-critical dimensions.</div>
    </div>
  );
}


// ── Diagram 7: Measurement Instrument Comparison ──────────────────
function DiagramInstruments() {
  const W = 900, H = 340;
  const instruments = [
    { name:'Gauge Block',        range:'0.5–100 mm',  res:'0.0001 µm', acc:'0.05–0.14 µm', app:'Transfer std, CMM cal', icon:'▬' },
    { name:'Micrometer',         range:'0–25 mm ext.', res:'0.5 µm',    acc:'± 2 µm',       app:'OD/ID, depth, thickness', icon:'🔩' },
    { name:'Vernier Caliper',    range:'0–300 mm',    res:'50 µm',      acc:'± 30 µm',      app:'Quick shop-floor checks', icon:'📏' },
    { name:'Dial Indicator',     range:'0–10 mm',     res:'1–10 µm',    acc:'± 5 µm',       app:'Runout, flatness, TIR', icon:'⏱' },
    { name:'CMM (Bridge)',       range:'300–2000 mm', res:'0.1 µm',     acc:'0.5–5 µm',     app:'Full GD&T inspection', icon:'🔬' },
    { name:'Optical Comparator', range:'0–300 mm',    res:'1 µm',       acc:'± 2 µm',       app:'Profiles, thread forms', icon:'🔭' },
    { name:'Laser Tracker',      range:'0–80 m',      res:'10 µm',      acc:'± 15 µm',      app:'Large-scale assembly', icon:'🎯' },
    { name:'Surface Profilometer',range:'Traversing', res:'0.01 µm',   acc:'Ra ± 5%',      app:'Ra, Rz, waviness', icon:'〰' },
  ];

  const colW = W / 4, rowH = 72;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Common Measurement Instruments — Range, Resolution &amp; Accuracy</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Header */}
        <rect x={0} y={0} width={W} height={28} fill="#1e7a36"/>
        {['Instrument','Meas. Range','Resolution / Accuracy','Typical Application'].map((h,i) => (
          <text key={i} x={i*colW + colW/2} y={19} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">{h}</text>
        ))}

        {instruments.map(({ name, range, res, acc, app, icon }, i) => {
          const row = Math.floor(i / 2);
          const col = i % 2 === 0 ? 0 : 2;
          const y = 28 + row * rowH;
          const bg = row % 2 === 0 ? '#edf7f0' : '#fff';
          return (
            <g key={i}>
              {/* Instrument name cell */}
              <rect x={col*colW} y={y} width={colW} height={rowH} fill={bg} stroke="#b6dfc0" strokeWidth="0.8"/>
              <text x={col*colW + 30} y={y+22} fontSize="13">{icon}</text>
              <text x={col*colW + 50} y={y+22} fontSize="11" fill="#145a24" fontWeight="700">{name}</text>
              {/* Range cell */}
              <rect x={(col+1)*colW} y={y} width={colW} height={rowH} fill={bg} stroke="#b6dfc0" strokeWidth="0.8"/>
              <text x={(col+1)*colW + 8} y={y+20} fontSize="10" fill="#546e7a">Range</text>
              <text x={(col+1)*colW + 8} y={y+35} fontSize="11" fill="#0a1f0e" fontFamily="'Courier New',monospace">{range}</text>
              <text x={(col+1)*colW + 8} y={y+50} fontSize="10" fill="#546e7a">Res: {res}</text>
              <text x={(col+1)*colW + 8} y={y+62} fontSize="10" fill="#c0392b">Acc: {acc}</text>
              {/* Note: Application shown as tooltip-style in next column position was merged above */}
              <text x={col*colW + 50} y={y+38} fontSize="10" fill="#555">{app}</text>
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>Instrument selection depends on the required measurement uncertainty (which must be ≤ 25% of the drawing tolerance per ASME B89 / ISO 14253), the measurement range, and the production environment. Gauge blocks (Grade K/0/1) are the primary transfer standards for length in most calibration labs. All instruments require periodic calibration with documented traceability.</div>
    </div>
  );
}

// ── Main export ────────────────────────────────────────────────────
export default function Metrology() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Metrology — Industrial Engineering</h1>
      <p style={S.p}>
        Metrology is the science of measurement. In industrial engineering it underpins every quality system, tolerance standard, and manufacturing process — without it, parts cannot be interchanged, assemblies cannot be qualified, and processes cannot be controlled. Industrial metrology encompasses dimensional measurement, surface texture, geometric tolerancing, calibration, and statistical analysis of measurement systems.
      </p>

      <InfoBox title="Core Concepts at a Glance" items={[
        "Traceability: every measurement must be linked by an unbroken chain to an SI unit definition via calibrated standards",
        "Measurement uncertainty (GUM): every result has an associated uncertainty U = k·u_c — not a single 'true' value",
        "GD&T (ASME Y14.5 / ISO 1101): symbolic language defining geometric tolerances beyond simple ±dimensions",
        "CMM (Coordinate Measuring Machine): primary instrument for 3D dimensional inspection; accuracy 0.5–5 µm",
        "Surface texture: Ra (mean roughness) and Rz (peak-to-valley) quantify micro-geometry per ISO 4287",
        "SPC (Statistical Process Control): X̄/R and X̄/s charts monitor process stability; Cp/Cpk measure capability",
        "Gauge R&R: measurement system analysis — repeatability (equipment variation) and reproducibility (appraiser variation)",
        "Rule of 10: measuring instrument accuracy should be at least 10× better than the tolerance being measured",
        "Abbe's principle: the measuring instrument should be aligned axially with the dimension being measured to avoid cosine error",
      ]}/>

      <h2 style={S.h2}>Metrological Traceability</h2>
      <p style={S.p}>
        Traceability is the property of a measurement result whereby it can be related to a reference through a documented, unbroken chain of calibrations, each contributing a stated measurement uncertainty. Without traceability, there is no international basis for comparing measurements between suppliers, customers, test labs, and regulatory bodies. The international system is coordinated through the BIPM (Bureau International des Poids et Mesures) and national metrology institutes (NMIs) such as NIST (USA), NPL (UK), and PTB (Germany).
      </p>
      <DiagramTraceability/>
      <Table2 rows={[
        ["SI metre definition","Since 2019: 1 metre = distance light travels in 1/299,792,458 s in vacuum\nPreviously: platinum-iridium prototype bar (until 1960), then krypton-86 wavelength"],
        ["Primary realisation","Iodine-stabilised He-Ne laser interferometry at NMIs\nUncertainty: ~10⁻¹¹ relative — effectively exact for industry"],
        ["Gauge blocks (slip gauges)","Wrung sets of hardened steel or tungsten carbide blocks\nGrades: K (0.05 µm/100 mm), 0 (0.1 µm), 1 (0.2 µm), 2 (0.45 µm)"],
        ["Calibration certificate","Must state: result, expanded uncertainty U, coverage factor k, traceability chain\nISO/IEC 17025 accreditation validates the lab's technical competence"],
        ["Calibration interval","Risk-based: depends on stability history, usage intensity, consequences of drift\nTypical: 1 year for micrometers, 6 months for CMM probes in production"],
        ["ISO/IEC 17025","Competence standard for testing and calibration laboratories\nRequires: method validation, uncertainty estimation, personnel competence, equipment control"],
      ]}/>

      <h2 style={S.h2}>Dimensional Measurement Instruments</h2>
      <p style={S.p}>
        The choice of measuring instrument is governed by the required measurement uncertainty (≤ 25–33% of the drawing tolerance per ISO 14253-1), the part size, the production environment, and the throughput requirement. Instruments range from simple hand tools to sophisticated multi-sensor CMMs.
      </p>
      <DiagramInstruments/>
      <Table2 rows={[
        ["Abbe's principle","Measurement axis must be collinear with the standard — avoids first-order cosine (Abbe) error\nMicrometer obeys Abbe's principle; vernier caliper does not (Abbe offset ≈ 15 mm)"],
        ["Cosine error","If gauge axis is tilted by angle α: error = L(1 − cosα) ≈ Lα²/2\nFor α = 1°, L = 100 mm: error ≈ 0.015 mm"],
        ["Gauge block wringing","Molecular adhesion between lapped surfaces creates near-zero gap (<25 nm)\nWrung stack uncertainty: σ_stack = √n × σ_block (n = number of blocks)"],
        ["Thermal expansion","ΔL = α · L · ΔT;  α_steel ≈ 11.5 × 10⁻⁶/°C\nFor L=200 mm, ΔT=1°C: ΔL ≈ 2.3 µm — dominant uncertainty for large parts"],
        ["Contact vs non-contact","Contact (stylus, probe): robust, high accuracy, scratches soft surfaces\nNon-contact (laser, optical, CT): fast, no force, but sensitive to surface finish, colour, reflectivity"],
        ["Rule of 10","Instrument resolution / accuracy should be ≤ 10% of the tolerance being measured\nE.g. IT7 tolerance on Ø50mm = 25 µm → use instrument with ≤ 2.5 µm resolution"],
      ]}/>

      <h2 style={S.h2}>Coordinate Measuring Machines (CMMs)</h2>
      <p style={S.p}>
        A CMM is a multi-axis measuring instrument that determines the spatial coordinates of points on a workpiece surface by means of a probing system. The collected points are fitted to geometric primitives — planes, cylinders, cones, spheres — by least-squares or Chebyshev algorithms, and the resulting geometric parameters are compared to drawing tolerances. Modern CMMs achieve volumetric accuracies of 0.5–5 µm over working volumes from 300 mm to several metres.
      </p>
      <DiagramCMM/>
      <Table2 rows={[
        ["ISO 10360 performance test","Probing performance E0, EL, P tests per ISO 10360-2\nEL = maximum permissible error (MPE) = A + L/K (µm); e.g. 1.8 + L/300 µm"],
        ["Probe qualification","Ruby ball stylus calibrated on reference sphere before each measurement\nDetermines effective stylus radius and tip position vector"],
        ["Temperature compensation","Workpiece and CMM must be at 20°C ± 0.5°C for calibrated results\nInfrared sensors on workpiece correct for differential thermal expansion in real time"],
        ["Scanning vs discrete points","Discrete touch-trigger: 0.5–2 pts/sec — fast for simple features\nScanning (analogue probe): 50–500 pts/sec — needed for form measurement"],
        ["Least-squares vs Chebyshev","Least-squares (Gaussian) fitting minimises sum of squared residuals — standard for most features\nChebyshev (minimax) minimises maximum deviation — used for mating/functional fits"],
        ["CMM software","DMIS programming language; major platforms: PC-DMIS, Calypso, Metrolog, Renishaw MODUS\nOff-line programming from CAD model reduces setup time 60–80%"],
        ["CMM uncertainty sources","Geometry errors (scale, squareness, straightness), probe qualification, thermal, fixturing, workpiece form\nCombined per ISO 15530-3 or GUM-based simulation (e.g. PUNDIT, VCMM)"],
      ]}/>

      <h2 style={S.h2}>Geometric Dimensioning &amp; Tolerancing (GD&T)</h2>
      <p style={S.p}>
        GD&T is the international symbolic language for communicating design intent on engineering drawings. It replaces ambiguous coordinate tolerances with geometrically meaningful tolerance zones tied to functional datums. The two dominant standards are ASME Y14.5-2018 (USA/global manufacturing) and ISO 1101:2017 (European / international), which are similar but differ in modifiers and some interpretations.
      </p>
      <DiagramGDT/>
      <Table2 rows={[
        ["Feature Control Frame (FCF)","□ symbol | tolerance value | datum references (A, B, C)\nRead as: 'The [geometric characteristic] of this feature shall be within [tolerance] relative to [datum]'"],
        ["Datum reference frame","Three mutually perpendicular planes A (primary), B (secondary), C (tertiary)\nEstablished from physical datum features using 3-2-1 contact rule"],
        ["MMC modifier ⓜ","Maximum Material Condition: feature is at its largest permissible size\nBonus tolerance = departure from MMC size → increases positional tolerance"],
        ["LMC modifier ⓛ","Least Material Condition: feature at smallest permissible size\nUsed to protect minimum wall thickness"],
        ["True position","Most powerful GD&T control — places axis/plane within cylindrical or planar zone\nDiameter symbol Ø before tolerance = cylindrical zone (more volume than square zone)"],
        ["Projected tolerance zone ⓟ","Tolerance zone projected above the part — controls interference in assembly\nCritical for threaded holes and press-fit pins"],
        ["GD&T vs coordinate tolerances","±X/Y/Y box tolerances create square/rectangular zones — accept fewer good parts\nGD&T cylindrical zones accept ~57% more parts for same design intent"],
        ["Datum shift","When datum feature is at MMC, datum axis/plane can shift relative to nominal\nExtra functional tolerance — reduces unnecessary reject rate"],
      ]}/>

      <h2 style={S.h2}>Measurement Uncertainty</h2>
      <p style={S.p}>
        The GUM (Guide to the Expression of Uncertainty in Measurement, JCGM 100:2008) defines the internationally accepted framework for quantifying measurement uncertainty. Every measurement result should be expressed as: result ± U (units), where U = k × u_c is the expanded uncertainty at a stated confidence level. For most industrial measurements, k = 2 gives approximately 95% confidence.
      </p>
      <DiagramUncertainty/>
      <Table2 rows={[
        ["Type A evaluation","Statistical analysis of repeated measurements: u_A = s/√n\nRequires ≥ 10 repeat measurements under defined conditions (ISO 5725)"],
        ["Type B evaluation","From prior knowledge: calibration certs, manufacturer specs, reference data, physics\nu_B = U_cert / k  (for a normal distribution stated with coverage factor k)"],
        ["Combined uncertainty","u_c = √(Σ(cᵢ·uᵢ)²)  where cᵢ = sensitivity coefficient (∂y/∂xᵢ)\nFor independent, uncorrelated inputs this simplifies to root-sum-of-squares"],
        ["Expanded uncertainty U","U = k · u_c  (k=2 for ~95%, k=3 for ~99.7% confidence)\nMust be reported on calibration certificates and measurement reports"],
        ["Conformance decision (ISO 14253-1)","Guard band = U → only accept if result + U < USL and result − U > LSL\n'Shared risk' requires result ± U fully within tolerance — not just point estimate"],
        ["Sensitivity coefficient cᵢ","∂y/∂xᵢ — how output changes with input xᵢ\nFor thermal expansion: c = α · L (coefficient × length)"],
        ["Degrees of freedom ν","Governs which t-distribution to use for coverage factor k\nν_eff calculated via Welch-Satterthwaite equation from all contributions"],
        ["Monte Carlo simulation","Alternative to GUM linear propagation — samples from all input distributions\nEssential when measurement model is non-linear or input distributions non-Gaussian"],
      ]}/>

      <h2 style={S.h2}>Surface Texture Measurement</h2>
      <p style={S.p}>
        Surface texture influences friction, wear, sealing performance, fatigue life, optical properties, and assembly function. It is characterised at three scales: roughness (short wavelength), waviness (medium), and form (long wavelength), separated by profile filters with cut-off wavelengths defined in ISO 4288.
      </p>
      <DiagramSurfaceRoughness/>
      <Table2 rows={[
        ["Ra — arithmetic mean roughness","Ra = (1/L)∫|z(x)|dx  — average absolute deviation from mean line\nMost widely specified; insensitive to occasional peaks/valleys"],
        ["Rz — max height of profile","Average of five highest peak-to-valley heights within evaluation length\nBetter predictor of sealing, wear, and fatigue performance than Ra"],
        ["Rq — RMS roughness","Rq = √[(1/L)∫z²(x)dx]  — root-mean-square of profile ordinates\nMore sensitive to peaks than Ra; used in optics and electronics"],
        ["Rsk — skewness","Third statistical moment — asymmetry of profile\nNegative Rsk (valley-dominated) retains lubricant; positive (peak-dominated) wears faster"],
        ["Cut-off wavelength λ_c","Separates roughness from waviness (ISO 4288 — depends on Ra range)\nTypical: λ_c = 0.8 mm for Ra 0.1–2 µm; 2.5 mm for Ra 2–10 µm"],
        ["Contact profilometer","Diamond stylus (2 µm radius) traverses surface; vertical resolution 1 nm\nISO 3274; cannot measure very fine textures without stylus damage"],
        ["Optical methods","White-light interferometry, confocal microscopy, coherence scanning\nNon-contact, 3D areal measurement per ISO 25178 — preferred for soft/reflective surfaces"],
        ["3D areal parameters (ISO 25178)","Sa (areal Ra), Sq, Sz, Ssk — extend 2D parameters to full surface\nCaptures lay, isotropy, and functional features missed by single-trace 2D measurement"],
        ["Process-roughness relation","Turning: Ra 0.8–12.5 µm;  Grinding: Ra 0.1–1.6 µm;  Lapping/honing: Ra 0.01–0.4 µm\nSuperfinishing/polishing: Ra < 0.025 µm (mirror)"],
      ]}/>

      <h2 style={S.h2}>Statistical Process Control &amp; Process Capability</h2>
      <p style={S.p}>
        SPC uses statistical methods to monitor and control manufacturing processes in real time. A process that is in statistical control (only common-cause variation) and capable (process spread fits within tolerances with margin) produces predictable output and minimises defects without 100% inspection.
      </p>
      <DiagramSPC/>
      <Table2 rows={[
        ["Control chart types","X̄/R (mean + range) for n=2–9; X̄/s (mean + std dev) for n≥10\nIndividuals/MR (X/mR) for n=1 (100% inspection or slow processes)"],
        ["Western Electric rules","Rule 1: 1 point beyond ±3σ  |  Rule 2: 9 points on same side of centre\nRule 3: 6 points trending  |  Rule 4: 14 alternating up/down"],
        ["Common vs special cause","Common cause: inherent random variation — reduce only by changing process\nSpecial cause: assignable, external event — investigate and eliminate immediately"],
        ["Cp — potential capability","Cp = (USL − LSL) / 6σ  (assumes centred process)\nCp = 1.0 → 0.27% defects; Cp = 1.33 → 64 ppm; Cp = 1.67 → 0.6 ppm"],
        ["Cpk — actual capability","Cpk = min[(USL−X̄)/3σ, (X̄−LSL)/3σ]\nCpk < Cp when process is off-centre — centering improvement increases Cpk at zero cost"],
        ["Six Sigma target","Cpk = 2.0 corresponds to 6σ from mean to nearest spec limit\nAllowing 1.5σ shift: 3.4 defects per million opportunities (DPMO)"],
        ["Gauge R&R (MSA)","Measurement System Analysis: decomposes observed variation into part + equipment + appraiser\n%GRR = 100 × σ_gauge / σ_total; target < 10% (acceptable), 10–30% marginal, >30% unacceptable"],
        ["AIAG MSA / ANOVA method","Crossed Gauge R&R: multiple appraisers × multiple parts × multiple reps\nANOVA separates repeatability, reproducibility, and part-to-part variation"],
        ["NDC — number of distinct categories","ndc = 1.41 × σ_part / σ_gauge  (must be ≥ 5 for adequate discrimination)\nndc < 5 means gauge cannot distinguish part variation well enough for SPC"],
      ]}/>

      <h2 style={S.h2}>Optical &amp; Non-Contact Measurement</h2>
      <Table2 rows={[
        ["Laser interferometry","Measures displacement by counting optical fringe patterns (λ/2 ≈ 316 nm/fringe for He-Ne laser)\nUsed for CMM scales, machine tool error mapping, gauge block calibration"],
        ["Structured light scanning","Projected fringe patterns deform over surface; triangulation gives 3D point cloud\nSpeed: 1–5 million pts/sec; accuracy 5–50 µm; used for reverse engineering and inspection"],
        ["Photogrammetry","Multiple calibrated photographs → 3D coordinates via bundle adjustment\nScale bars provide traceability; accuracy 10–50 µm over 0.5–10 m volumes"],
        ["Laser tracker","Retroreflector target tracked by laser ranging + angle encoders\nRange 0–80 m; accuracy ±15 µm + 6 µm/m; used for large aerospace/shipbuilding assemblies"],
        ["X-ray computed tomography (CT)","Rotational X-ray projections → 3D voxel model of internal and external geometry\nInspects internal features impossible with surface contact probes; accuracy 1–50 µm"],
        ["Vision systems / machine vision","Camera + structured illumination; checks 2D features (holes, edges, surface defects) at line speed\n100–1000 parts/min; sub-pixel accuracy (1–5 µm) with telecentric lenses"],
        ["Confocal microscopy","Pinhole aperture eliminates out-of-focus light; optical sectioning gives 3D surface map\nVertical resolution < 1 nm; lateral 0.2 µm; used for electronics and precision optics"],
        ["Roundness / form testers","Rotating spindle with contact transducer; separates form error from surface roughness\nSpindle accuracy: < 0.01 µm; measures roundness, cylindricity, coaxiality"],
      ]}/>

      <h2 style={S.h2}>Metrology in Quality Systems &amp; Standards</h2>
      <Table2 rows={[
        ["ISO 9001:2015 Cl. 7.1.5","Monitoring and measuring resources must be calibrated at specified intervals\nCalibration records are mandatory quality records — must be retained"],
        ["ISO/IEC 17025:2017","Accreditation standard for calibration and testing laboratories\nRequires: measurement uncertainty, traceability, method validation, impartiality"],
        ["IATF 16949 (automotive)","Extends ISO 9001 — requires MSA (AIAG manual), Cp/Cpk ≥ 1.33, control plans\nCustomer-specific requirements (CSR) may exceed these minimums"],
        ["ISO 14253-1 (conformance)","Rules for accepting or rejecting workpieces: guard-band approach using measurement uncertainty\nDefault: subtract U from tolerance — protects customer from false accept"],
        ["VDA 5 (German automotive)","Measurement process suitability: Q = measurement uncertainty / tolerance × 100%\nTarget: Q ≤ 15%; marginal 15–30%; inadequate > 30%"],
        ["ASME B89 series","US standards for dimensional metrology instruments (CMMs, surface plates, micrometers)\nB89.4.22 CMM uncertainty; B89.1.9 gauge blocks; B89.3.1 roundness"],
        ["GD&T standards","ASME Y14.5-2018 (USA) and ISO 1101:2017 (international) — not fully interchangeable\nISO GPS (Geometrical Product Specifications) series extends ISO 1101"],
        ["BIPM / CIPM MRA","Mutual Recognition Arrangement: calibration certificates from accredited NMI labs are\ninternationally recognised — eliminates re-calibration when parts cross borders"],
      ]}/>

      <InfoBox title="Key Formulae Summary" items={[
        "Measurement uncertainty (GUM): u_c = √(Σ cᵢ² · uᵢ²)   [cᵢ = sensitivity coefficient, uᵢ = standard uncertainty of input xᵢ]",
        "Expanded uncertainty: U = k · u_c   (k = 2 for ~95% confidence; k = 3 for ~99.7%)",
        "Thermal expansion correction: ΔL = α · L · ΔT   [α_steel ≈ 11.5×10⁻⁶/°C; reference temperature = 20°C]",
        "Process capability: Cp = (USL − LSL) / 6σ   |   Cpk = min[(USL−X̄)/3σ,  (X̄−LSL)/3σ]",
        "Gauge R&R: σ²_total = σ²_part + σ²_repeatability + σ²_reproducibility   (%GRR = 100·σ_gauge/σ_total)",
        "Abbe error: δ = h · sin(θ) ≈ h · θ   [h = Abbe offset (mm), θ = angular error (rad)]",
        "Cosine error: ΔL = L · (1 − cos α) ≈ L · α² / 2   [α = misalignment angle]",
        "Ra (arithmetic mean roughness): Ra = (1/L) ∫₀ᴸ |z(x)| dx   (ISO 4287)",
        "Probing error (CMM): E₀ = probing form + qualification uncertainty + thermal drift",
        "Number of distinct categories: ndc = 1.41 × (σ_part / σ_gauge)   (must be ≥ 5 for SPC use)",
      ]}/>
    </div>
  );
}